// import React, { useState } from "react";

// const ConventionHall = () => {
//   const [showBooking, setShowBooking] = useState(false);
//   const [selectedImage, setSelectedImage] = useState(null);

//   const facilityList = [
//     "🎤 Sound System & AV Equipment",
//     "🪑 Premium Seating Arrangements",
//     "📶 High-Speed Wi-Fi",
//     "🍽️ Catering Services",
//     "🚗 Ample Parking",
//     "🌿 Outdoor Lawn Area",
//   ];

//   const galleryImages = [
//     "https://res.cloudinary.com/dxdvcplbl/image/upload/v1757178988/convention1.jpg",
//     "https://res.cloudinary.com/dxdvcplbl/image/upload/v1757178988/convention2.jpg",
//     "https://res.cloudinary.com/dxdvcplbl/image/upload/v1757178988/convention3.jpg",
//     "https://res.cloudinary.com/dxdvcplbl/image/upload/v1757178988/convention4.jpg",
//   ];

//   return (
//     <div className="bg-[#fdfdfc] min-h-screen py-12 px-6 md:px-20">
//       <div className="max-w-7xl mx-auto">
//         {/* Title */}
//         <h1 className="text-4xl font-bold text-center mb-12">
//           🏛️ Convention Hall
//         </h1>

//         <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//           {/* Left Column */}
//           <div className="md:col-span-2 space-y-8">
//             {/* Operating Hours */}
//             <div className="bg-white shadow-lg p-6 rounded-2xl border hover:shadow-xl transition">
//               <h2 className="text-2xl font-semibold mb-4">
//                 ⏰ Operating Hours
//               </h2>
//               <ul className="space-y-2 text-gray-700">
//                 <li>Monday - Sunday: 8:00 AM - 11:00 PM</li>
//               </ul>
//               <div className="mt-6">
//                 <button
//                   onClick={() => setShowBooking(true)}
//                   className="relative group overflow-hidden bg-lime-400 text-black font-bold py-3 px-6 rounded-full w-full flex items-center justify-center transition-colors duration-500"
//                 >
//                   <span className="absolute inset-0 bg-black origin-bottom-left scale-x-0 group-hover:scale-x-100 transition-transform duration-700 ease-in-out z-0"></span>
//                   <span className="relative z-10 uppercase group-hover:text-white transition-colors duration-500">
//                     Prebook the Hall
//                   </span>
//                 </button>
//               </div>
//             </div>

//             {/* Facilities */}
//             <div className="bg-white shadow-lg p-6 rounded-2xl border hover:shadow-xl transition">
//               <h2 className="text-2xl font-semibold mb-4">🛠️ Facilities</h2>
//               <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700">
//                 {facilityList.map((item, idx) => (
//                   <li key={idx} className="bg-gray-100 p-3 rounded-lg">
//                     {item}
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* Gallery */}
//             <div className="bg-white shadow-lg p-6 rounded-2xl border hover:shadow-xl transition">
//               <h2 className="text-2xl font-semibold mb-4">🖼️ Gallery</h2>
//               <div className="flex overflow-x-auto gap-4 pb-4 scrollbar-hide">
//                 {galleryImages.map((img, idx) => (
//                   <img
//                     key={idx}
//                     src={img}
//                     alt={`Hall ${idx + 1}`}
//                     className="w-48 h-32 rounded-lg shadow hover:scale-105 transition-transform cursor-pointer flex-shrink-0"
//                     onClick={() => setSelectedImage(img)}
//                   />
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* Right Column - Capacity */}
//           <div className="bg-white shadow-lg p-6 rounded-2xl border hover:shadow-xl transition flex flex-col justify-between">
//             <div>
//               <h2 className="text-2xl font-semibold mb-4">👥 Capacity</h2>
//               <p className="text-gray-700 text-lg">
//                 Our convention hall can comfortably host up to:
//               </p>
//               <ul className="list-disc pl-6 mt-4 text-gray-700 space-y-2">
//                 <li>🎉 300 guests (Banquet Style)</li>
//                 <li>🎓 400 guests (Theatre Style)</li>
//                 <li>🗣️ 250 guests (Conference Style)</li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Prebook Modal */}
//       {showBooking && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
//           onClick={() => setShowBooking(false)}
//         >
//           <div
//             className="relative bg-white p-6 rounded-2xl shadow-lg w-full max-w-md"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               className="absolute top-2 right-2 text-gray-700 bg-gray-200 rounded-full px-3 py-1 hover:bg-gray-300"
//               onClick={() => setShowBooking(false)}
//             >
//               ✕
//             </button>
//             <h2 className="text-2xl font-semibold mb-4 text-center">
//               📝 Prebook the Hall
//             </h2>
//             <form
//               className="grid gap-4"
//               onSubmit={(e) => {
//                 e.preventDefault();
//                 setShowBooking(false); // Close modal on submit
//               }}
//             >
//               <input
//                 type="text"
//                 placeholder="Your Name"
//                 className="border rounded-lg p-3 focus:ring-2 focus:ring-indigo-400 outline-none"
//               />
//               <input
//                 type="date"
//                 className="border rounded-lg p-3 focus:ring-2 focus:ring-indigo-400 outline-none"
//               />
//               <input
//                 type="text"
//                 placeholder="Type of Event"
//                 className="border rounded-lg p-3 focus:ring-2 focus:ring-indigo-400 outline-none"
//               />
//               <input
//                 type="number"
//                 placeholder="Expected Guests"
//                 className="border rounded-lg p-3 focus:ring-2 focus:ring-indigo-400 outline-none"
//               />
//               <button
//                 type="submit"
//                 className="bg-lime-500 hover:bg-lime-600 uppercase text-black py-3 px-4 rounded-lg font-semibold transition"
//               >
//                 Reserve Now
//               </button>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Image Modal */}
//       {selectedImage && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
//           onClick={() => setSelectedImage(null)}
//         >
//           <div
//             className="relative bg-white p-4 rounded-2xl shadow-lg"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               className="absolute top-2 right-2 text-gray-700 bg-gray-200 rounded-full px-3 py-1 hover:bg-gray-300"
//               onClick={() => setSelectedImage(null)}
//             >
//               ✕
//             </button>
//             <img
//               src={selectedImage}
//               alt="Enlarged view"
//               className="max-w-[90vw] max-h-[80vh] rounded-lg"
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ConventionHall;
import React, { useState, useEffect } from "react";

const ConventionHall = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showBooking, setShowBooking] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const facilityList = [
    "🎤 Sound System & AV Equipment",
    "🪑 Premium Seating Arrangements",
    "📶 High-Speed Wi-Fi",
    "🍽️ Catering Services",
    "🚗 Ample Parking",
    "🌿 Outdoor Lawn Area",
    "🎨 Stage & Lighting Setup",
    "🖥️ Projector & Screens",
    "💺 VIP Lounge",
    "🧹 Cleaning Services",
    "🥂 Bar Services",
    "🎸 Live Music Setup",
    "🛡️ Security Services",
    "🛋️ Lounge Furniture",
    "🌸 Decoration Options",
    "🪟 Air Conditioning",
  ];

  const galleryImages = [
    "https://res.cloudinary.com/dxdvcplbl/image/upload/v1757782074/convention_2-min_ay2m2s.jpg",
    "https://res.cloudinary.com/dxdvcplbl/image/upload/v1757782063/convention_3-min_fsbysp.jpg",
    "https://res.cloudinary.com/dxdvcplbl/image/upload/v1757782064/convention_1-min_mlwwpc.jpg",
    "https://res.cloudinary.com/dxdvcplbl/image/upload/v1757782061/convention_4-min_ywmmhb.jpg",
  ];

  // Auto slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % galleryImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-[#fdfdfc] min-h-screen py-12 px-6 md:px-20">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-bold text-center mb-5 uppercase">
          Convention Hall
        </h1>

        {/* Carousel */}
        <div className="relative mb-12 overflow-hidden rounded-3xl shadow-2xl">
          <div
            className="flex transition-transform duration-1000 ease-in-out"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {galleryImages.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={`Hall ${idx + 1}`}
                className="w-full h-80 md:h-[500px] object-cover flex-shrink-0 cursor-pointer hover:scale-105 transition-transform rounded-3xl"
                onClick={() => setSelectedImage(img)}
              />
            ))}
          </div>

          {/* Dots */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
            {galleryImages.map((_, idx) => (
              <div
                key={idx}
                className={`w-3 h-3 rounded-full ${
                  idx === currentSlide ? "bg-lime-500" : "bg-gray-300"
                }`}
              ></div>
            ))}
          </div>
        </div>

        {/* Facilities */}
        <div className="bg-white shadow-2xl rounded-3xl p-6 mb-12 border border-gray-200 max-h-96 overflow-y-auto">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-lime-600">
            🛠️ Available Facilities
          </h2>
          <ul className="space-y-3">
            {facilityList.map((facility, idx) => (
              <li
                key={idx}
                className="p-3 bg-indigo-50 text-lime-800 rounded-xl shadow-sm hover:shadow-md transition flex items-center gap-3"
              >
                {facility}
              </li>
            ))}
          </ul>
        </div>

        {/* Prebook & Contact */}
        {/* <div className="bg-gradient-to-r from-indigo-50 via-white to-indigo-50 shadow-2xl rounded-3xl p-8 text-center border border-indigo-100 transform transition hover:-translate-y-1 hover:scale-105">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-indigo-700">
            📞 Prebook & Contact
          </h2>
          <p className="text-lg md:text-xl font-medium text-gray-800 mb-4">
            Reserve your spot or inquire about our facilities.
          </p>
          <button
            onClick={() => setShowBooking(true)}
            className="bg-indigo-500 text-white py-3 px-6 md:px-8 rounded-full font-semibold shadow-lg transition transform hover:scale-105 hover:shadow-2xl"
          >
            Prebook Now
          </button>
        </div> */}
        <div className="bg-gradient-to-r from-indigo-50 via-white to-indigo-50 shadow-2xl rounded-3xl p-6 md:p-8 text-center border border-indigo-100 transition transform hover:-translate-y-1 hover:scale-105 mb-12">
          <h2 className="text-xl sm:text-2xl font-bold mb-4 text-lime-700">
            ⏰ Opening Hours
          </h2>
          <ul className="space-y-1 sm:space-y-2 text-gray-700 mb-4 sm:mb-6">
            <li>Monday - Friday: 10:00 AM - 10:00 PM</li>
            <li>Saturday - Sunday: 9:00 AM - 11:00 PM</li>
          </ul>
          <h3 className="text-xl sm:text-2xl font-bold mb-2 text-lime-600">
            For Pre-Booking
          </h3>
          <p className="text-base sm:text-lg font-medium text-gray-800">
            Call: +88 01766693142
          </p>
        </div>
      </div>

      {/* Booking Modal */}
      {showBooking && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={() => setShowBooking(false)}
        >
          <div
            className="relative bg-white p-6 rounded-2xl shadow-lg w-full max-w-md"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-2 right-2 text-gray-700 bg-gray-200 rounded-full px-3 py-1 hover:bg-gray-300"
              onClick={() => setShowBooking(false)}
            >
              ✕
            </button>
            <h2 className="text-2xl font-semibold mb-4 text-center">
              📝 Prebook the Hall
            </h2>
            <form
              className="grid gap-4"
              onSubmit={(e) => {
                e.preventDefault();
                setShowBooking(false);
              }}
            >
              <input
                type="text"
                placeholder="Your Name"
                className="border rounded-lg p-3 focus:ring-2 focus:ring-indigo-400 outline-none"
              />
              <input
                type="date"
                className="border rounded-lg p-3 focus:ring-2 focus:ring-indigo-400 outline-none"
              />
              <input
                type="text"
                placeholder="Type of Event"
                className="border rounded-lg p-3 focus:ring-2 focus:ring-indigo-400 outline-none"
              />
              <input
                type="number"
                placeholder="Expected Guests"
                className="border rounded-lg p-3 focus:ring-2 focus:ring-indigo-400 outline-none"
              />
              <button
                type="submit"
                className="bg-indigo-500 hover:bg-indigo-600 text-white py-3 px-4 rounded-lg font-semibold transition"
              >
                Reserve Now
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Image Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={() => setSelectedImage(null)}
        >
          <div
            className="relative bg-white p-4 rounded-2xl shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-2 right-2 text-gray-700 bg-gray-200 rounded-full px-3 py-1 hover:bg-gray-300"
              onClick={() => setSelectedImage(null)}
            >
              ✕
            </button>
            <img
              src={selectedImage}
              alt="Enlarged view"
              className="max-w-[90vw] max-h-[80vh] rounded-lg"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ConventionHall;
